<script>
  import { onMount, createEventDispatcher, onDestroy } from "svelte";
  import { fly } from "svelte/transition";
  import { Router, Route, Link, navigate } from "svelte-routing";
  import { account, appSession } from "../stores/app.js";
  import JumpseatRequests from "./JumpseatRequests.svelte";
  import Search from "./Search.svelte";
  import Map from "./Map.svelte";
  import IdentityCard from "./IdentityCard.svelte";
  import Profile from "./Profile.svelte";
  import Password from "./Password.svelte";
  import Subscription from "./Subscription.svelte";
  import RestPilots from "../components/RestPilots.svelte";
  import { DateTime } from "luxon";

  export let googleMapsReady;

  const dispatch = createEventDispatcher();

  let sideMenu = null;
  let currentPage = "/";
  let overlayPage = null;
  let restEmptyLegEnquiries = null;
  let restJumpseatRequests = null;
  let subscriptionTimer = null;
  let restPilots = null;

  onMount(async () => {
    let elems = document.querySelectorAll(".sidenav");
    let sidenavInstances = M.Sidenav.init(elems, {});
    sideMenu = sidenavInstances[0];

    subscriptionTimer = setInterval(() => {
      updateSubscriptionStatus();
    }, 1000 * 60 * 5);
  });

  onDestroy(() => {
    if (subscriptionTimer) clearInterval(subscriptionTimer);
  });

  function ShowPage(page) {
    currentPage = page;
    navigate(page);
  }

  async function updateSubscriptionStatus() {
    if ($appSession.authorisationToken == null) return; // not signed in

    try {
      let pilot = await restPilots.GetPilots(
        $appSession.pilotId,
        "fields=stripe_subscription_status,stripe_subscription_end"
      );

      let subscriptionExpired = false;
      if (pilot.stripe_subscription_status == "inactive") subscriptionExpired = true;
      else {
        let subscriptionExpiresTime = DateTime.fromISO(pilot.stripe_subscription_end.replace(" ", "T"), {
          zone: "UTC",
        });
        subscriptionExpiresTime = subscriptionExpiresTime.plus({ hours: 48 });
        let nowUTC = DateTime.utc();
        if (subscriptionExpiresTime < nowUTC) subscriptionExpired = true;
      }

      account.update((current) => {
        return { ...current, subscriptionExpired: subscriptionExpired };
      });
    } catch (error) {
      console.log(error);
    }
  }
</script>

<main>

  <div class="navbar-fixed">
    <nav>
      <div class="nav-wrapper jumphub-blue darken-1">
        <div class="container">

          <span class="left show-on-small hide-on-med-and-up" style="font-size: 2.7em;">
            <img src="assets/logo-menu-small.png" alt="" />
          </span>

          <span class="left show-on-medium hide-on-small-only" style="font-size: 2.7em;">
            <img src="assets/logo-menu.png" alt="" />
          </span>

          <ul id="nav-mobile" class="right">

            <li class={currentPage == '/' ? 'active' : ''} style="width: 54px; text-align: center;">
              <a
                href="#!"
                on:click={() => {
                  ShowPage('/');
                }}>
                <img src="assets/jumpseat-menu.png" alt="" style="vertical-align: text-bottom;" />
              </a>
            </li>

            <li class={currentPage == '/search' ? 'active' : ''}>
              <a
                href="#!"
                on:click={() => {
                  ShowPage('/search');
                }}>
                <i class="material-icons">search</i>
              </a>
            </li>

            <li class={currentPage == '/map' ? 'active' : ''}>
              <a
                href="#!"
                on:click={() => {
                  ShowPage('/map');
                }}>
                <i class="material-icons">map</i>
              </a>
            </li>

            <li class={currentPage == '/identitycard' ? 'active' : ''}>
              <a
                href="#!"
                on:click={() => {
                  ShowPage('/identitycard');
                }}>
                <i class="material-icons">perm_identity</i>
              </a>
            </li>

            <li>
              <a href="#!" on:click|preventDefault={() => sideMenu.open()}>
                <i class="material-icons">more_vert</i>
              </a>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  </div>

  <div class="sidenav">

    <div style="background-color: #111; color: #fff; padding: 20px 35px; font-size: 1em; line-height: 1.75em;">

      <div class="truncate">
        <h6>{$account.name}</h6>
        {$account.email}
        <button
          class="btn-flat wave-effect blue-grey lighten-1 white-text"
          on:click={() => {
            sideMenu.close();
            dispatch('logout', {});
          }}
          style="margin-top: 10px; display: block; font-size: 0.75em; padding-left: 10px; padding-right: 10px; height:
          auto; line-height: 2em;">
          Sign-out
        </button>

      </div>
    </div>

    <ul>
      <li>
        <a href="#!" class="subheader">Account</a>
      </li>
      <li>
        <a
          href="#!"
          class="waves-effect sidenav-close"
          on:click={() => {
            overlayPage = 'profile';
          }}>
          Details
        </a>
      </li>
      <li>
        <a
          href="#!"
          class="waves-effect sidenav-close"
          on:click={() => {
            overlayPage = 'password';
          }}>
          Password
        </a>
      </li>
      <li>
        <a
          href="#!"
          class="waves-effect sidenav-close"
          on:click={() => {
            overlayPage = 'subscription';
          }}>
          Subscription
        </a>
      </li>
    </ul>

    <div
      class="container hide-on-med-only"
      style="font-size: 0.65em; text-align: center; margin-top: 40px; color: #ccc;">
      <div style="word-spacing: 10px; margin-bottom: 10px; text-transform: uppercase;">
        <a href="https://www.jumphub.aero/terms-and-conditions" target=_blank>Legal</a>
        <a href="mailto:customersupport@jumphub.aero">Support</a>
      </div>
      <div>
        Copyright &copy; 2022 Jumphub LLC
        <br />
        All Rights Reserved
      </div>
    </div>

  </div>

  <div class="container">
    <Route path="" component={JumpseatRequests} />
    <Route path="/" component={JumpseatRequests} />
    <Route path="/search" component={Search} />
    <Route path="/identitycard" component={IdentityCard} />
    <Route path="/map">
      <Map {googleMapsReady}/>
    </Route>
  </div>

</main>

<footer class="page-footer jumphub-blue darken-1 hide-on-small-only" style="padding-top: 15px;">
  <div
    class="container"
    style="font-size: 0.75em; padding-bottom: 15px; display: flex; justify-content: space-between; align-items: center;">
    <div>
      Copyright &copy; 2022 Jumphub LLC
      <br />
      All Rights Reserved
    </div>
    <div style="word-spacing: 10px;">
      <a href="https://www.jumphub.aero/terms-and-conditions" class="grey-text text-lighten-4" target=_blank>Legal</a>
      <a href="mailto:customersupport@jumphub.aero" class="grey-text text-lighten-4">Support</a>
    </div>
  </div>
</footer>

{#if overlayPage == 'profile'}
  <Profile
    on:close={() => {
      overlayPage = null;
    }} />
{/if}

{#if overlayPage == 'password'}
  <Password
    on:close={() => {
      overlayPage = null;
    }} />
{/if}

{#if overlayPage == 'subscription'}
  <Subscription
    on:close={() => {
      overlayPage = null;
    }} />
{/if}

<RestPilots bind:this={restPilots} />
